import React from 'react'
import { experiences } from '../constants'
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import CTA from '../components/CTA';

const Experience = () => {
  return (
    <section className='max-container'>
      <div className='py-16'>
        <h3 className='subhead-text'>
          Experience
        </h3>
        <div className='mt-5 flex flex-col gap-3 text-slate-500'>
        <p className='font-semibold'>As a member of college clubs, I contributed to a dynamic community, honing my skills in various domains. From organizing impactful events to collaborating on cutting-edge projects, each experience shaped my perspective and fueled my commitment to excellence. Explore the highlights of my club journey and the valuable lessons learned along the way.</p>
      </div>
      <div className='mt-12 flex'>
          <VerticalTimeline>
            {experiences.map((experience)=>(
              <VerticalTimelineElement
                key={experience.company_name}
                date={experience.date}
                icon={
                  <div className='flex justify-center items-center w-full h-full'>
                    <img
                      src={experience.icon}
                      alt={experience.company_name}
                      className='w-[60%] h-[60%] object-contain '
                    />
                  </div>
                }
                iconStyle={{background:experience.iconBg}}
                contentStyle={{
                  borderBottom:'8px',
                  borderStyle:'solid',
                  borderBottomColor:experience.iconBg,
                  boxShadow:'none',
                }}
              >
                <div>
                  <h3 className='text-black text-xl font-poppins font-semibold'>
                    {experience.title}
                  </h3>
                  <p className='text-black-500 font-medium font-base' style={{margin:0}}>
                    {experience.company_name}
                  </p>
                </div>
                <ul className='my-5 list-disc ml-5 space-y-2'>
                  {experience.points.map((point,index)=>(
                    <li key={`experience-point-${index}`} className='text-black-500/50 font-normal pl-1'>
                      {point}
                    </li>
                  ))}
                  {experience.title==="Competitive Programming Lead" && (
                    <li className='text-black-500/50 font-normal pl-1'>
                      <a href='https://codechefvitcc.vercel.app/' target='_blank' className='text-blue-500 underline'>Website Link</a>
                    </li>
                  )}
                </ul>
              </VerticalTimelineElement>
            ))}
          </VerticalTimeline>
      </div>
      </div>
      <hr className='border-slate-200'/>
      <CTA/>
    </section>
  )
}

export default Experience;